import { AdCardModal } from "./ads/AdSlots";
import { Hud } from "./hud/Hud";
import { Phone } from "./phone/Phone";
import { ZonePrompt } from "./hud/ZonePrompt";
import { QuestTracker } from "./hud/QuestTracker";
import { MapOverlay, Minimap } from "./map/IslandMap";
import { DrivePad } from "./hud/DrivePad";
import { CarHud } from "./hud/CarHud";
import { EventModal, RankUpCard, RektScreen } from "./modals/Modals";
import { hud, phoneOpen, toast, togglePhone } from "./bridge";
import { RunToggle } from "./hud/RunToggle";
import { PersonCard } from "./modals/PersonCard";
import { HelpModal } from "./modals/Help";
import { IslandPrompts } from "./modals/IslandPrompts";
import { AccountModal, ConflictModal, SignInPrompt } from "./modals/Account";

export function App() {
  return (
    <>
      <Hud />
      {!phoneOpen.value && (
        <button class="phone-fab" onClick={togglePhone} aria-label="Open phone (P)">
          📱
          {(hud.value?.unread ?? 0) > 0 && <span class="app-badge">{hud.value!.unread}</span>}
        </button>
      )}
      <QuestTracker />
      <Minimap />
      <ZonePrompt />
      <DrivePad />
      <CarHud />
      <RunToggle />
      <Phone />
      <MapOverlay />
      <RankUpCard />
      <EventModal />
      <RektScreen />
      <PersonCard />
      <HelpModal />
      <IslandPrompts />
      <SignInPrompt />
      <AccountModal />
      <ConflictModal />
      <AdCardModal />
      {toast.value && (
        <div class="toast" role="status">
          {toast.value}
        </div>
      )}
    </>
  );
}
